import { socket, refreshAdminSocketAuth } from "../containers/ChatPage/socket";
import { presenceTypes } from "../reducers/presenceReducer";

// ===== Подписка на конкретную комнату (редактор сметы)
export const joinPresenceRoom = ({ roomId, user }) => {
  return (dispatch) => {
    const handler = ({ roomId: rid, users }) => {
      if (rid !== roomId) return;
      dispatch({ type: presenceTypes.SET_ROOM_USERS, payload: { roomId: rid, users: users || [] } });
    };

    const join = () => {
      socket.emit("presence:join", { roomId, user });
      socket.emit("presence:who", { roomId });
    };

    refreshAdminSocketAuth();
    socket.on("presence:update", handler);
    socket.on("connect", join);

    if (socket.connected) {
      join();
    }

    return () => {
      socket.off("presence:update", handler);
      socket.off("connect", join);

      if (socket.connected) {
        socket.emit("presence:leave", { roomId, user });
      }
    };
  };
};

// ===== Пуллим сводную статистику по ряду комнат (список смет)
export const watchPresenceStats = ({ roomIds = [], prefix = "estimate:" , intervalMs = 5000 }) => {
  return (dispatch) => {
    let timer = null;

    const tick = () => {
      socket.emit("presence:stats", { roomIds: roomIds.map(id => `${prefix}${id}`), prefix }, (ack) => {
        if (ack?.ok) {
          dispatch({ type: presenceTypes.MERGE_STATS, payload: { rooms: ack.rooms || {} } });
        }
      });
    };

    // первый запрос сразу, затем по интервалу
    tick();
    timer = setInterval(tick, intervalMs);

    return () => {
      clearInterval(timer);
      dispatch({ type: presenceTypes.CLEAR_STATS });
    };
  };
};
